import React from "react";
import Card from "components/ui/Card/Card";
import Icon from "components/ui/Icon/Icon";
import styles from "./HomePage.module.scss";
import { useI18n } from "context/I18nContext";

const shortcutConfig = [
  { icon: "dashboard", key: "dashboard", to: "/dashboard" },
  { icon: "account", key: "account", to: "/accounts" },
  { icon: "recharge", key: "recharge", to: "/recharge" },
  { icon: "water", key: "waterTransaction", to: "/transactions/water" },
  { icon: "card", key: "card", to: "/cards" },
];

function HomePage() {
  const { t } = useI18n();

  return (
    <div className={styles.wrapper}>
      <div className={styles.shortcuts}>
        {shortcutConfig.map((shortcut) => (
          <Card
            key={shortcut.key}
            onClick={() => (window.location.href = shortcut.to)}
          >
            <div className={styles.shortcut}>
              <div className={styles.iconWrap}>
                <Icon name={shortcut.icon} />
              </div>
              <div className={styles.title}>
                {t(`homePage.shortcuts.${shortcut.key}`)}
              </div>
            </div>
          </Card>
        ))}
      </div>

    </div>
  );
}

export default HomePage;
